import api from '../../api/menus';
import { find, chain, forOwn } from 'lodash';
import {MENU_IDS} from '../../options/constants';

export default {
    state: {
        menus: [],
        mainNavVisible: false
    },
    mutations: {
        setMenu(state, data) {
            state.menus = chain(state.menus)
                .concat(data)
                .uniqBy('ID')
                .value();
        },
        setMainNavState(state, data) {
            state.mainNavVisible = data;
        },
    },
    actions: {
        fetchModuleData() {
            let self = this;
            forOwn(MENU_IDS, function (value) {
                self.dispatch('fetchMenu', value);
            });
        },
        fetchMenu({ commit }, menu_id) {
            return new Promise((resolve) => {
                api.get(`menus/${ menu_id }/`)
                    .then((response) => {
                        commit('setMenu', response.data);
                        resolve();
                    });
            });
        },
    },

    getters: {
        getMenuByID(state) {
            return (id) => {
                if ( state.menus ) {
                    return find(state.menus, {ID: parseInt(id, 10)});
                }
                return null;
            };
        },
        getMainNavState(state) {
            return () => {
                return state.mainNavVisible;
            };
        },
    },
};